import { createStackSiderViewHook } from '@/providers/StackSiderViewProvider';

export const useAiChatStackSiderView = createStackSiderViewHook('ai-chat');
